import * as PromoActions from '../actions/promo';
var initialState = null;
export default function balance(state, action) {
    if (state === void 0) { state = initialState; }
    if (action === void 0) { action = {}; }
    switch (action.type) {
        case PromoActions.SUCCESS_FETCH_APPEND_PROMO_VISIT:
            if (action.data.redirectTo) {
                return action.data.redirectTo;
            }
            return state;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/promoReducer.js